module.exports = __webpack_public_path__ + "static/media/bat_logo.64dacd62.svg";